import React, { Component } from 'react'

class Consent extends Component {
  state = {
    checkedConsent: null,
    processing: false,
    errorMessage: ''
  }

  consentAgreement = () => {
    return {
      sellerId: this.props.sellerId,
      design: { designMode: 'responsive' },
      onReady: (billingAgreementConsentStatus) => {
        this.checkedConsent = billingAgreementConsentStatus.getConsentStatus()
      },
      onConsent: (billingAgreementConsentStatus) => {
        this.checkedConsent = billingAgreementConsentStatus.getConsentStatus()
       },
      onError: function(error) {
        console.log(error)
      }
    }
  }

  submitPayment(agreementId) {
    if (agreementId && this.checkedConsent === 'true') {
      this.setState({ processing: true, errorMessage: '' })
      this.props.subscribe(agreementId)
    } else {
      this.setState({ errorMessage: 'You have to check the consent box in order to proceed.' })
    }
  }

  render() {
    const amazonBillingAgreementId = this.props.billingAgreement.getAmazonBillingAgreementId()
    new window.OffAmazonPayments.Widgets.Consent(
      this.consentAgreement(amazonBillingAgreementId)
    ).bind('consentWidgetDiv')

    return (
      <div className="consent">
        <div id="consentWidgetDiv" />
        <div className="btn-wrapper">
          <button 
            onClick={() => this.submitPayment(amazonBillingAgreementId)} 
            className="subscribe-btn"
          >
            { this.state.processing ? 'Processing...' : 'Submit' }
          </button>  
          { this.state.errorMessage && <p className="error-message">{this.state.errorMessage}</p> }
        </div>
      </div>
    )
  }
}

export default Consent